import React, { FC } from 'react';
import { ModalX, ModalXProps } from '../../../BaseComponents';
import LoginForm from './Component';
import { Props as LoginFormProps } from './BaseComponent/BaseComponent';

interface Props {
	modalProps: ModalXProps;
	loginFormProps: LoginFormProps;
}

const LoginFormModal: FC<Props> = ({ modalProps, loginFormProps }) => {
	return (
		<ModalX size="medium" {...modalProps}>
			<LoginForm {...loginFormProps} />
		</ModalX>
	);
};

export default LoginFormModal;
